var map = {
	"./151-rum-shot.json": 87430,
	"./aam-panna.json": 93669,
	"./aamras.json": 4652,
	"./abc-juice.json": 39814,
	"./across-the-pacific.json": 27308,
	"./adonis.json": 26613,
	"./adult-hot-chocolate.json": 82490,
	"./affogato.json": 81876,
	"./afterglow.json": 18600,
	"./agua-de-bandido.json": 43987,
	"./agua-de-valencia.json": 91159,
	"./aguapanela.json": 23886,
	"./airmail.json": 47584,
	"./ajoblanco.json": 70428,
	"./alien-brain-hemorrhage.json": 23852,
	"./almond-banana-smoothie.json": 13987,
	"./amaretto-sour.json": 20026,
	"./amarula-thai-tea.json": 18326,
	"./american-trilogy.json": 52942,
	"./americano.json": 77408,
	"./amf.json": 80743,
	"./amrit-chai.json": 74688,
	"./angevine-soup.json": 49318,
	"./aperol-spritz.json": 33431,
	"./apertass.json": 78134,
	"./apple-cider-margarita.json": 47110,
	"./apple-cider-mimosa.json": 43982,
	"./apple-cider-mules.json": 91450,
	"./apple-jack.json": 31081,
	"./apple-liqueur.json": 129,
	"./apple-orchard-punch.json": 7696,
	"./apple-pie-cocktail.json": 16213,
	"./appletini.json": 73957,
	"./april-rain.json": 24684,
	"./aqueduct.json": 1237,
	"./argentinian-mate.json": 40685,
	"./astronaut.json": 43036,
	"./aviation.json": 90530,
	"./ayran.json": 25092,
	"./b-52.json": 13103,
	"./baby-guinness.json": 21148,
	"./bacardi-cocktail.json": 9842,
	"./bael-panna.json": 12194,
	"./bahama-mama.json": 76092,
	"./bajigur.json": 60273,
	"./banana-cocoa.json": 1554,
	"./banana-smoothie.json": 4595,
	"./bandrek.json": 72536,
	"./bandung.json": 81226,
	"./bangkok-sunrise.json": 83956,
	"./barley-drink.json": 92431,
	"./barnamint-baileys.json": 81337,
	"./barracuda.json": 59416,
	"./barraquito.json": 12149,
	"./basil-kadha.json": 44002,
	"./basil-smash-pina-colada.json": 44671,
	"./basil-smash.json": 75961,
	"./batanga.json": 66131,
	"./bay-breeze.json": 42069,
	"./beam-me-up-scotchie.json": 30798,
	"./beer-pletok.json": 55521,
	"./beergarita.json": 89281,
	"./bees-kiss.json": 70509,
	"./bees-knees.json": 80541,
	"./bellini.json": 71150,
	"./bentley.json": 37892,
	"./beras-kencur.json": 25061,
	"./berry-and-oat-smoothie.json": 80549,
	"./berry-shrub.json": 7226,
	"./berrylicious-frozen-sangria-slush.json": 22758,
	"./beton.json": 34225,
	"./between-the-sheets.json": 46336,
	"./bijou.json": 72986,
	"./bikini-martini.json": 39498,
	"./birthday-cake-shot.json": 23266,
	"./bitter-but-good.json": 78149,
	"./black-martini.json": 83559,
	"./black-russian.json": 19096,
	"./black-velvet.json": 53621,
	"./black-widow.json": 42679,
	"./blackberry-thyme-margarita.json": 82107,
	"./blackthorn-cocktail.json": 35426,
	"./blood-and-sand.json": 14264,
	"./blood-orange-champagne-mule.json": 96227,
	"./bloody-eyeball-shot.json": 49342,
	"./bloody-geisha.json": 98138,
	"./bloody-kirby.json": 63776,
	"./bloody-mary.json": 35138,
	"./blow-job-cocktail.json": 42120,
	"./blue-hawaiian-cocktail.json": 39403,
	"./blue-kamikaze-shot.json": 63606,
	"./blue-lady.json": 74040,
	"./blue-lagoon.json": 37032,
	"./blue-monday.json": 31056,
	"./blue-oasis.json": 58689,
	"./blue-vodka-lemonade.json": 20525,
	"./blueberry-banana-smoothie.json": 87394,
	"./boba-tea.json": 35280,
	"./bobby-burns.json": 27586,
	"./bombeirinho.json": 87589,
	"./boomerang.json": 21707,
	"./boulevardier.json": 80147,
	"./bourbon-lemonade.json": 60786,
	"./bourbon-mule.json": 59798,
	"./bourbon-old-fashioned.json": 77704,
	"./boza.json": 14255,
	"./brain-damage.json": 83687,
	"./bramble.json": 7568,
	"./brandy-alexander.json": 14862,
	"./brandy-sour.json": 41433,
	"./brandy-wine-punch.json": 14948,
	"./brass-monkey.json": 52920,
	"./brazilian-coconut-cocktail.json": 85024,
	"./brazilian-limeade.json": 54363,
	"./brazilian-strawberry-drink.json": 41394,
	"./breakfast-club-cocktail.json": 46746,
	"./breakfast-mai-tai.json": 93065,
	"./breakfast-martini.json": 79253,
	"./bruce-wayne.json": 89395,
	"./brunswick-cocktail.json": 98342,
	"./buffalo-sweat.json": 51571,
	"./bullfisher.json": 24353,
	"./burnt-caramel-manhattan.json": 15269,
	"./butter-coffee.json": 11582,
	"./buttermilk.json": 98848,
	"./buttery-nipple.json": 33339,
	"./cable-car.json": 63241,
	"./cafeconleche.json": 76579,
	"./caferio-cookie-shake.json": 3796,
	"./caipipink.json": 24771,
	"./caipireja.json": 84491,
	"./caipirinha-black.json": 9137,
	"./caipirinha-red-fruit.json": 9778,
	"./caipirinha.json": 50195,
	"./caipiroska.json": 91997,
	"./calamansi-juice.json": 22111,
	"./calamity-jane.json": 17738,
	"./californication.json": 71162,
	"./canelazo.json": 40408,
	"./cantarito-tequila.json": 87880,
	"./cape-codder.json": 2372,
	"./capeta.json": 65741,
	"./cappuccino.json": 97498,
	"./carajillo.json": 9954,
	"./caramel-apple-shot.json": 59422,
	"./caramel-frappuccino.json": 16055,
	"./caramel-snickerdoodle-martini.json": 39480,
	"./carrulim.json": 91870,
	"./casino.json": 30982,
	"./cement-mixer.json": 61037,
	"./cendol.json": 61996,
	"./chai-e-zanjafeel.json": 36075,
	"./champagne-soup.json": 96459,
	"./cheerwine.json": 50467,
	"./cherry-bourbon-smash.json": 49743,
	"./cherry-limeade.json": 86678,
	"./chikoo-lassi.json": 97897,
	"./chocolate-cake-shot.json": 14631,
	"./chocolate-milk.json": 98423,
	"./chocolate-monkey.json": 23449,
	"./chocoline.json": 15855,
	"./christmas-tonic.json": 3879,
	"./chuhai.json": 21329,
	"./churchill.json": 37565,
	"./cinnamon-maple-whiskey.json": 13541,
	"./citrus-martini.json": 80376,
	"./clarito.json": 15077,
	"./classic-whiskey-sour.json": 61058,
	"./clavis-riga.json": 29297,
	"./clericot.json": 12890,
	"./clover-club-cocktail.json": 31400,
	"./coco-avocado.json": 80097,
	"./coco-dream.json": 51735,
	"./coco-loco.json": 17223,
	"./coco-piñarita.json": 55479,
	"./coconut-coffee.json": 98023,
	"./coconut-lime-cilantro-cooler.json": 91996,
	"./coconut-margarita.json": 17463,
	"./coconut-mint-collins.json": 91584,
	"./cold-brew-old-fashioned.json": 41802,
	"./cold-brew.json": 90,
	"./cold-coffee.json": 39046,
	"./cold-relief-tea.json": 47920,
	"./colombian-michelada.json": 84042,
	"./colorado-bulldog.json": 45322,
	"./comfort-colllins.json": 4212,
	"./coquito.json": 19049,
	"./corn-juice.json": 63942,
	"./coronarita.json": 86823,
	"./corpse-reviver-no2.json": 18608,
	"./cosmopolitan.json": 88801,
	"./cranberry-bourbon.json": 5067,
	"./cranberry-mimosa.json": 24978,
	"./cranberry-orange-whiskey.json": 76173,
	"./cranberry-tonic.json": 34877,
	"./creamy-indian-espresso.json": 71271,
	"./creamy-mango-lassi.json": 94518,
	"./creole-cream.json": 37068,
	"./crock-pot-butterbeer-rum.json": 83473,
	"./crusta.json": 315,
	"./cuba-libre.json": 10791,
	"./cuban-zombie.json": 6267,
	"./cucumber-gin.json": 25094,
	"./cucumber-lemonade.json": 19961,
	"./cucumber-lime-mint-agua-fresca.json": 91420,
	"./cynar-spritz.json": 41213,
	"./daddy-dont-go.json": 880,
	"./daiquiri.json": 39207,
	"./dalgona-coffee.json": 52604,
	"./danish-summer.json": 85770,
	"./dark-and-stormy.json": 26868,
	"./dawet-rice-flours.json": 98914,
	"./dayak-onion-tea.json": 47294,
	"./death-in-the-afternoon.json": 74084,
	"./death-in-the-gulf-stream.json": 7981,
	"./debonair.json": 78139,
	"./desert-colada.json": 38673,
	"./desi-borhani.json": 35566,
	"./detox-green-juice.json": 41542,
	"./detox-green-tea.json": 58220,
	"./devils-ice-tea.json": 10395,
	"./devils-own.json": 43851,
	"./dianas-lips.json": 30682,
	"./dirty-snowmen.json": 9147,
	"./dolce-vita.json": 62477,
	"./dole-whip-lemonade.json": 71814,
	"./dom-pedro.json": 78008,
	"./doodh-cola.json": 12429,
	"./dorflinger.json": 66727,
	"./dr-disaronno.json": 46575,
	"./dragon-fruit-smoothie.json": 71400,
	"./dragons-breath-mojito.json": 82507,
	"./drunken-monkey.json": 360,
	"./drunken-peanut-butter-cups.json": 80237,
	"./dubliner.json": 7592,
	"./dutchmans-daiquiri.json": 24769,
	"./earl-grey-gin-tea.json": 9827,
	"./easy-sangria.json": 711,
	"./egg-coffee.json": 84641,
	"./eggnog.json": 29450,
	"./egyptian-fakhfakhina.json": 96891,
	"./egyptian-sobia-drink.json": 35228,
	"./el-diablo.json": 71782,
	"./el-presidente.json": 37432,
	"./elderflower-cooler.json": 64529,
	"./elderflower-french-75.json": 12782,
	"./elderflower-tini.json": 28133,
	"./embuscade.json": 40948,
	"./english-garden-cocktail.json": 76168,
	"./es-jeruk.json": 91325,
	"./es-sarang-burung.json": 9542,
	"./espanhola.json": 82138,
	"./espresso-martini.json": 66626,
	"./fall-old-fashioned.json": 98116,
	"./fast-food-classic.json": 33279,
	"./fernet-with-coke.json": 69037,
	"./fig-bourbon-cider-smash.json": 6892,
	"./figaro-cocktail.json": 15264,
	"./fireball-hot-toddies.json": 15819,
	"./fireball-shot.json": 24191,
	"./firetruck-emergency-response.json": 28032,
	"./firetruck.json": 83324,
	"./flaming-engineer.json": 18700,
	"./flaming-moe.json": 4485,
	"./four-horsemen-shot.json": 54830,
	"./french-75.json": 28856,
	"./french-martini.json": 95522,
	"./french-pearl.json": 20212,
	"./french-sangria.json": 9013,
	"./frose.json": 42998,
	"./frosted-lemonade.json": 45314,
	"./frozen-cantaloupe-margarita.json": 37809,
	"./fuzzy-navel.json": 39790,
	"./galack-colada.json": 65001,
	"./galaxie.json": 5836,
	"./gazpacho.json": 28006,
	"./gibson.json": 12499,
	"./gimlet.json": 20977,
	"./gin-coke.json": 2962,
	"./gin-elderflower-fizz.json": 98435,
	"./gin-fizz-with-pomegranate.json": 88690,
	"./gin-fizz.json": 88905,
	"./gin-sour.json": 45317,
	"./gin-tonic.json": 64325,
	"./gin-tonica.json": 24440,
	"./ginger-infused-water.json": 51256,
	"./ginger-lemon-tea.json": 59372,
	"./ginger-lime-whiskey-sour.json": 37768,
	"./ginger-milk-tea.json": 89108,
	"./ginger-mint-tea.json": 13751,
	"./gingerbread-eggnog.json": 5175,
	"./gingerbread-latte.json": 16770,
	"./glogg.json": 11549,
	"./gluhwein.json": 39032,
	"./godchild.json": 56577,
	"./godfather.json": 81659,
	"./golden-brown.json": 41009,
	"./golden-glow-water.json": 23404,
	"./golden-slipper.json": 17364,
	"./good-vibrations.json": 41344,
	"./grandmas-apple-pie-ala-mode-moonshine.json": 31228,
	"./grass-jelly-drink.json": 34451,
	"./grasshopper.json": 89047,
	"./green-beast.json": 50722,
	"./green-lagoon.json": 19363,
	"./green-mango-sharbat.json": 36349,
	"./greyhound.json": 19844,
	"./grilled-grapefruit-paloma-cocktail.json": 90762,
	"./grinch-drinks.json": 16648,
	"./grog.json": 20462,
	"./guarapita.json": 43373,
	"./guayacolita.json": 97424,
	"./hanky-panky.json": 55242,
	"./happy-soda.json": 50377,
	"./hard-applecider.json": 6632,
	"./harry-potter-butterbeer.json": 7009,
	"./hi-fi.json": 89600,
	"./hibiscus-cherry-vodka-spritz.json": 48044,
	"./hibiscus-mint-tea.json": 42215,
	"./hiroshima.json": 31675,
	"./hocus-pocus.json": 83190,
	"./homemade-blackberry-lemonade.json": 96615,
	"./homemade-whiteclaw.json": 80860,
	"./honey-bee-mine.json": 77123,
	"./honey-carrot.json": 20128,
	"./honey-egg-juice.json": 80889,
	"./honey-spearmint-tea.json": 9271,
	"./horachata.json": 86402,
	"./horchata-water.json": 22281,
	"./hot-buttered-rum.json": 8937,
	"./hot-espresso.json": 98263,
	"./hot-toddy.json": 99793,
	"./hot-water.json": 92056,
	"./hugo.json": 21372,
	"./hurricane.json": 63668,
	"./ice-cold-water.json": 17923,
	"./iced-coffee-frappe.json": 60344,
	"./iced-matcha-latte.json": 72488,
	"./immune-boosting-smoothie.json": 67169,
	"./income-tax.json": 58226,
	"./indian-summer.json": 39632,
	"./indonesian-avocado-milkshake.json": 56131,
	"./irish-blues.json": 4110,
	"./irish-breakfast-shot.json": 92389,
	"./irish-car-bomb.json": 66708,
	"./irish-coffee.json": 78253,
	"./irish-winter.json": 3604,
	"./italian-cream-soda.json": 97818,
	"./jack-frosties.json": 74896,
	"./jacqueline.json": 25512,
	"./jager-ginger.json": 32993,
	"./jagerbomb.json": 42530,
	"./jaljeera.json": 66333,
	"./jam-band.json": 31285,
	"./jamaican-mule.json": 13973,
	"./jammy-dodger-shot.json": 45502,
	"./jamun-panna.json": 32391,
	"./jamun-shots.json": 81296,
	"./japanese-highball.json": 6092,
	"./japanese-ice-tea.json": 9023,
	"./jasmine-milk-tea.json": 53233,
	"./jaunelemonricard.json": 10614,
	"./jello-shots.json": 9365,
	"./jungle-bird.json": 38704,
	"./kalimotxo.json": 68567,
	"./kamikaze-shot.json": 45253,
	"./kansas-city-ice-water.json": 238,
	"./karkade.json": 22358,
	"./kenyan-dawa.json": 39673,
	"./kerala-sunset.json": 4300,
	"./khoshaf.json": 75831,
	"./kiba-smoothie.json": 45507,
	"./kids-hot-chocolate.json": 28405,
	"./killer.json": 99542,
	"./kir-royale.json": 21146,
	"./kiwi-caipisake.json": 89872,
	"./kiwi-cucumber-cooler.json": 19769,
	"./kokam-sherbat.json": 18960,
	"./kokum-stings.json": 87463,
	"./kombucha-vodka-highball.json": 54959,
	"./kopi.json": 9044,
	"./la-vie-en-rose.json": 13219,
	"./lafayette.json": 22348,
	"./latte.json": 63365,
	"./lava-flow.json": 51266,
	"./lavender-basil-lemonade.json": 31218,
	"./lavender-latte.json": 58297,
	"./lazy-sunday.json": 8710,
	"./lemon-cointreau-fizz.json": 39293,
	"./lemon-drop.json": 28658,
	"./lemon-stylus.json": 16373,
	"./lemonade.json": 35200,
	"./libertine.json": 31109,
	"./lillet-buck.json": 92221,
	"./lime-mojito.json": 74143,
	"./limerol.json": 12453,
	"./limoncello-spritz.json": 6252,
	"./london-fog.json": 16018,
	"./long-island-iced-tea.json": 57772,
	"./lust-for-life.json": 28332,
	"./lynchburg-lemonade.json": 1925,
	"./macunaima.json": 86747,
	"./madeleine.json": 67943,
	"./madras.json": 14137,
	"./magic-eye-juice.json": 94245,
	"./mai-tai.json": 76517,
	"./malibu-island-cosmo.json": 52359,
	"./malibu-sunset.json": 34826,
	"./mangalorean-tea.json": 35439,
	"./mango-daiquiri.json": 46774,
	"./mango-iced-tea.json": 98582,
	"./mango-juice.json": 41220,
	"./mango-lassi.json": 68228,
	"./mango-mastani.json": 60817,
	"./mango-mocktail.json": 97480,
	"./mango-nojito-mocktail.json": 60422,
	"./mango-peach-smoothie.json": 17772,
	"./mango-shake.json": 43610,
	"./mango-yakult-juice.json": 69947,
	"./manhattan.json": 30267,
	"./maple-bourbon-smash.json": 8673,
	"./margarita.json": 17501,
	"./marpha.json": 74666,
	"./marquisette.json": 61427,
	"./martini-royale.json": 46158,
	"./martini.json": 72625,
	"./masala-chaas.json": 68015,
	"./masala-chai.json": 38634,
	"./masala-coke.json": 81097,
	"./matcha-green-russian.json": 97451,
	"./matcha-green-tea-smoothie.json": 63551,
	"./matcha-latte.json": 50002,
	"./medicine-ball-tea.json": 24778,
	"./meia-de-seda.json": 46833,
	"./mexican-candy-shot.json": 7825,
	"./mexican-lagrimas-de-virgen.json": 80043,
	"./mexican-mule.json": 17096,
	"./mexican-sonora-michelada.json": 8900,
	"./mexican-strawberry-water.json": 2506,
	"./mezcal-with-jalapeno-pepper.json": 18148,
	"./miami-vice.json": 5786,
	"./michelada-zero-proof.json": 91803,
	"./midnight-in-paris.json": 89185,
	"./milk-punch.json": 39147,
	"./milk-tea.json": 96981,
	"./milo-dinosaur.json": 3858,
	"./mimosa.json": 29239,
	"./mind-eraser.json": 22356,
	"./mint-chocolate-milkshake.json": 2800,
	"./mint-citrus-water.json": 62388,
	"./mint-julep.json": 40890,
	"./mix-berry.json": 99828,
	"./mocha.json": 15065,
	"./mojito.json": 17113,
	"./monaco.json": 66030,
	"./monkey-gland.json": 12393,
	"./montreal-mule.json": 34051,
	"./moscato-mules.json": 54208,
	"./moscow-breeze.json": 87283,
	"./moscow-mule-simple.json": 50270,
	"./moscow-mule.json": 95553,
	"./mr-peanut-shake.json": 98047,
	"./mudslide.json": 70022,
	"./mulled-apple-crumble-cider.json": 5388,
	"./mulled-wine.json": 3032,
	"./muskmelon-panaka.json": 28465,
	"./nam-thom.json": 57138,
	"./nannari-sarabath.json": 20669,
	"./negroni-sbagliato.json": 64610,
	"./negroni.json": 99271,
	"./negroski.json": 3515,
	"./negrumi.json": 91642,
	"./nevada.json": 18898,
	"./new-york-sour.json": 96015,
	"./newfoundland-christmas-slush.json": 9375,
	"./nice-holiday.json": 7493,
	"./nigerian-chapman.json": 9625,
	"./nimbu-pani.json": 34291,
	"./noche-caliente.json": 46908,
	"./noon-chai.json": 27099,
	"./north-pole.json": 86465,
	"./norwegian-glogg.json": 67784,
	"./nutella-milkshake.json": 25212,
	"./oatmilk-shaken-espresso.json": 14326,
	"./old-cuban.json": 24382,
	"./old-fashioned.json": 68662,
	"./orange-carrot-smoothie.json": 15764,
	"./orange-earl-grey-iced-tea.json": 42871,
	"./orange-glorius.json": 56699,
	"./orange-ouzo-cocktail.json": 87130,
	"./orange-pineapple-moscow-mule.json": 18139,
	"./orangeade.json": 59237,
	"./oreo-frappe.json": 13993,
	"./oreo-milkshake.json": 54238,
	"./orgasm.json": 16188,
	"./ozark-speedball.json": 78831,
	"./p2.json": 91015,
	"./paan-shot.json": 44928,
	"./painkiller.json": 5054,
	"./palembang-red-bean-ice.json": 64967,
	"./palm-sugar-sharbat.json": 70012,
	"./paloma.json": 50457,
	"./panty-ripper.json": 50208,
	"./papaya-gin-sling.json": 10960,
	"./papaya-milk.json": 1889,
	"./paper-plane.json": 38338,
	"./passion-star-martini.json": 74050,
	"./peach-bellini.json": 17306,
	"./peach-fizz.json": 80672,
	"./peach-green-tea-lemonade.json": 83447,
	"./peach-martini.json": 90773,
	"./peach-ring-shot.json": 85434,
	"./peach-thyme-whiskey-smash.json": 84044,
	"./peanut-butter-banana-smoothie.json": 95280,
	"./pear-manhattan-cocktail.json": 14805,
	"./penicillin.json": 56336,
	"./peppermint-bark-mimosa.json": 99703,
	"./peppermint-shake.json": 40986,
	"./pick-a-daisy.json": 80909,
	"./pickleback-shot.json": 28755,
	"./pimms.json": 58989,
	"./pina-colada.json": 52120,
	"./pineapple-juice.json": 76144,
	"./pineapple-lemonade.json": 47001,
	"./pineapple-lime-beer-margarita.json": 80389,
	"./pineapple-shot.json": 40316,
	"./pineapple-upside-down-shot.json": 78856,
	"./pink-gin.json": 4546,
	"./pink-grapefruit-margarita.json": 83852,
	"./pink-lady.json": 92808,
	"./pink-ouzo.json": 92419,
	"./pisco-sour.json": 51833,
	"./planters-punch.json": 9707,
	"./pok-shot.json": 87364,
	"./polar-bear-danish.json": 99466,
	"./polar-bear.json": 43644,
	"./pomegranate-lemon-mint.json": 93929,
	"./pomegranate-margarita.json": 37851,
	"./pomegranate-martini.json": 12035,
	"./pompous-mexican.json": 35966,
	"./pornstar-martini.json": 88923,
	"./port-tonic.json": 41426,
	"./pudina-sherbet.json": 26910,
	"./puka-punch.json": 4027,
	"./pumpkin-juice.json": 86130,
	"./pumpkin-spice-latte.json": 76055,
	"./pumpkintini.json": 57341,
	"./purple-basil-sherbet.json": 72211,
	"./purple-haze.json": 38044,
	"./queimada.json": 96544,
	"./quick-demise.json": 72870,
	"./quick-milk-tea.json": 38387,
	"./rabo-de-galo.json": 10637,
	"./ramos-gin-fizz.json": 59888,
	"./ranch-water.json": 85367,
	"./raspberry-caipirinha.json": 1958,
	"./raspberry-drink.json": 38082,
	"./rebujito.json": 32165,
	"./red-stag-dirty-shirley.json": 80414,
	"./red-velvet-hot-chocolate.json": 46292,
	"./red-wine-spritzer.json": 4414,
	"./resentin.json": 42821,
	"./rich-hot-cocoa.json": 18843,
	"./rob-roy.json": 37967,
	"./romulan-ale.json": 82750,
	"./rooh-afza-milkshake.json": 35752,
	"./rooibos-peach-tea.json": 71125,
	"./rooibos-punch.json": 87487,
	"./rose-milk.json": 79282,
	"./rose-sangria.json": 42378,
	"./rosemary-horses-neck.json": 8414,
	"./rosemarycano.json": 36130,
	"./rossini.json": 77402,
	"./rosy-gin-kombucha-cocktail.json": 93227,
	"./royal-milk-tea.json": 27695,
	"./royal-mojito.json": 84363,
	"./rum-and-coke.json": 77860,
	"./rum-old-fashioned.json": 38843,
	"./rum-punch.json": 36254,
	"./rumchata-bourbon.json": 44638,
	"./rumple-minze-shot.json": 65549,
	"./rusty-nail.json": 77185,
	"./rye-tai.json": 7376,
	"./rysgaards-corona-special.json": 73268,
	"./safari-coke.json": 73482,
	"./salty-grapefruit-refresher.json": 67717,
	"./sambharam.json": 72371,
	"./sangria.json": 95358,
	"./savage-banana-soup.json": 88046,
	"./sayran.json": 7029,
	"./sazerac.json": 20866,
	"./sbagliato.json": 58723,
	"./scivolo.json": 89780,
	"./scotch-soda.json": 59779,
	"./screamsicle.json": 82198,
	"./screwdriver.json": 10889,
	"./sea-breeze.json": 67768,
	"./selendang-mayang.json": 3764,
	"./sergeant-pepper.json": 82453,
	"./serviceberry-sour.json": 12266,
	"./seven-devils.json": 11974,
	"./sex-in-the-driveway.json": 91317,
	"./sex-on-the-beach.json": 7827,
	"./sgroppino.json": 77096,
	"./shandy.json": 98470,
	"./shembot.json": 61645,
	"./shikanji.json": 52316,
	"./shirley-temple.json": 22185,
	"./sidecar.json": 23104,
	"./singapore-sling.json": 52393,
	"./skeleton-key-cocktail.json": 43921,
	"./slippery-nipple.json": 64430,
	"./sloe-tom-collins.json": 85660,
	"./smirnoff-black-russian.json": 82727,
	"./snake-bite.json": 72168,
	"./snowball-cocktail.json": 32420,
	"./soju-sprite-yakult.json": 87061,
	"./solkadhi.json": 80800,
	"./somaek.json": 42685,
	"./sonic-screwdriver.json": 25672,
	"./sour-apple-martini.json": 90662,
	"./south-african-ginger-beer.json": 97191,
	"./southside.json": 23701,
	"./spaghett.json": 86145,
	"./sparkling-campari-orange.json": 11679,
	"./sparkling-fall-sangria.json": 37108,
	"./sparkling-punch.json": 54071,
	"./spezi.json": 21384,
	"./spiced-harvest-fall-sangria.json": 88179,
	"./spicy-grapefruit-margarita.json": 70232,
	"./spicy-red-beer.json": 49908,
	"./spicy-tamarind-margarita.json": 66797,
	"./spicyorange.json": 68487,
	"./springbokkie.json": 91467,
	"./spritz-pomegranate.json": 47007,
	"./spritz.json": 19765,
	"./stinger.json": 91085,
	"./stmj.json": 56313,
	"./stone-sour.json": 76852,
	"./stoned-gimlet.json": 40265,
	"./straight-tequila-shot.json": 55732,
	"./straight-whiskey-shot.json": 7799,
	"./strawberry-banana.json": 71614,
	"./strawberry-cheesecake-shot.json": 50209,
	"./strawberry-daiquiri.json": 1101,
	"./strawberry-ginger-turmeric-tea.json": 7956,
	"./strawberry-limeade.json": 1042,
	"./strawberry-margarita.json": 44943,
	"./strawberry-mojita.json": 92645,
	"./strawberry-saquerinha.json": 40518,
	"./strawberry-sunrise-smoothie.json": 42117,
	"./strawberry-watermelon-juice.json": 90068,
	"./submarino.json": 56113,
	"./sugarcane-juice.json": 1169,
	"./sunshine-cocktail.json": 16145,
	"./swan-song-cocktail.json": 19195,
	"./swedish-libre.json": 32349,
	"./sweet-dreams.json": 88786,
	"./sweet-lassi.json": 58034,
	"./swinging-sultan.json": 52733,
	"./targoviste-twist.json": 69805,
	"./taro-fresh-milk.json": 51992,
	"./taste-the-rainbow.json": 78785,
	"./tea-ais.json": 77859,
	"./teh-c.json": 70450,
	"./teh-tarik.json": 48256,
	"./tequila-honeysuckle.json": 76971,
	"./tequila-mocking-bird.json": 75837,
	"./tequila-pineapple.json": 82603,
	"./tequila-slammer.json": 36730,
	"./tequila-sunrise.json": 44718,
	"./terere.json": 37098,
	"./thai-tea-with-almond-milk.json": 45575,
	"./thandai.json": 40224,
	"./the-bengal-tiger.json": 97222,
	"./the-diddy.json": 62503,
	"./the-flaming-homer.json": 25227,
	"./the-last-word.json": 62690,
	"./the-perfect-storm.json": 71196,
	"./the-salty-dog.json": 52489,
	"./the-swedish-tart.json": 94198,
	"./thyme-to-kill.json": 35407,
	"./tinto-de-verano.json": 38605,
	"./toddy-coconut.json": 27649,
	"./tom-collins.json": 21968,
	"./tom-yum.json": 10755,
	"./tomato-ricard.json": 47417,
	"./tongba.json": 43986,
	"./tornado-twist.json": 58904,
	"./traffic-light-shot.json": 36182,
	"./trash-can.json": 33686,
	"./tropical-sangria.json": 78873,
	"./tropical-smoothie.json": 2420,
	"./tschunk.json": 96145,
	"./turkish-buttermilk.json": 22631,
	"./turmeric-latte.json": 21907,
	"./tuxedo.json": 69136,
	"./two-one-two.json": 56559,
	"./umeshu-sparkling.json": 35864,
	"./urak.json": 25582,
	"./vaca-preta.json": 16215,
	"./vampiro.json": 543,
	"./vanilla-palm.json": 85439,
	"./vegan-iced-milk-tea.json": 82531,
	"./vegas-bomb.json": 57172,
	"./velvet-elvis.json": 92035,
	"./venom.json": 61974,
	"./venus-flytrap.json": 85649,
	"./vesper.json": 8524,
	"./vietnamese-coffee.json": 44477,
	"./vieux-carre.json": 95596,
	"./vinho-quente.json": 1500,
	"./virgin-belgian-orange-blossom.json": 96110,
	"./virgin-margarita.json": 14683,
	"./virgin-mary.json": 76780,
	"./virgin-mojito.json": 71707,
	"./virgin-strawberry-colada.json": 67523,
	"./vodka-irish-coffee.json": 2265,
	"./vodka-lemonade-punch.json": 48993,
	"./vodka-martini.json": 89405,
	"./vodka-red-bull.json": 8746,
	"./vodka-schweppes.json": 8857,
	"./vodka-soda.json": 67324,
	"./warm-lemon-honey-tea.json": 89527,
	"./warm-water.json": 99186,
	"./washington-apple.json": 46818,
	"./water-chestnut-drink.json": 7088,
	"./watermelon-agua-fresca.json": 67003,
	"./watermelon-lemonade.json": 80159,
	"./watermelon-mint-lemonade.json": 66200,
	"./watermelon-moscow-mule.json": 9768,
	"./watermelon-smoothie.json": 40614,
	"./watermelon-vodka.json": 68099,
	"./wedang-uwuh.json": 71405,
	"./werthers-hot-toddies.json": 16184,
	"./whiskey-boulevardier.json": 53682,
	"./whiskey-highball.json": 93557,
	"./whiskey-smash.json": 28652,
	"./whiskey-sour-vegas-style.json": 28234,
	"./whisky-sour.json": 26636,
	"./white-bear.json": 54271,
	"./white-christmas-margarita.json": 88112,
	"./white-christmas-mojito.json": 96514,
	"./white-freezie.json": 31889,
	"./white-lady.json": 64861,
	"./white-russian.json": 37054,
	"./white-wine-sangria.json": 29728,
	"./witches-heart.json": 78285,
	"./woo-woo.json": 26961,
	"./yale-cocktail.json": 66661,
	"./yellow-watermelon-juice.json": 15707,
	"./yogurt-fruit-shake.json": 22571,
	"./yogurt-lassi.json": 62598,
	"./zanzibar-ricard.json": 75616,
	"./zombie.json": 64215,
	"./zorbatini.json": 73335
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38645;